import { Box, Button } from '@mui/material';

export const LESSON_DID_NOT_LOAD_MESSAGE = "This lesson didn't load.";
/** MUS-651: a phrase that did not load partway through a tier, over a staff that has phrases. */
export const NEXT_PHRASE_DID_NOT_LOAD_MESSAGE = "The next phrase didn't load.";

interface LessonDidNotLoadProps {
  /** What did not load; the whole lesson unless said otherwise. */
  message?: string;
  /** Try the load again. Leave out when there is nothing a retry could fix. */
  onRetry?: () => void;
  onBackToRoadmap: () => void;
}

// Above the game and the video it covers (z-index 1 to 10 there), and below
// the paywall and the offline screen (see StackingLevels), which give their
// own way on and must never be painted over.
export const LESSON_DID_NOT_LOAD_Z_INDEX = 11;

const buttonSx = { minWidth: '140px', minHeight: '44px' };

/**
 * MUS-651: what a lesson or tutorial screen shows in place of content that did
 * not arrive, so the screen is never blank with no way on. It covers the screen
 * it is placed in.
 */
const LessonDidNotLoad = ({
  message = LESSON_DID_NOT_LOAD_MESSAGE,
  onRetry,
  onBackToRoadmap,
}: LessonDidNotLoadProps) => (
  <Box
    role="alertdialog"
    aria-modal="true"
    aria-label={message}
    data-testid="lesson-did-not-load"
    sx={{
      position: 'absolute',
      inset: 0,
      zIndex: LESSON_DID_NOT_LOAD_Z_INDEX,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '20px',
      padding: '16px',
      backgroundColor: 'rgba(29, 47, 68, 0.94)',
      color: '#fff',
      textAlign: 'center',
    }}
  >
    <Box component="p" sx={{ margin: 0, fontSize: { xs: '18px', md: '24px' }, fontWeight: 700 }}>
      {message}
    </Box>
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '12px', justifyContent: 'center' }}>
      {onRetry && (
        <Button variant="contained" onClick={onRetry} autoFocus sx={buttonSx}>
          Retry
        </Button>
      )}
      <Button
        variant="outlined"
        onClick={onBackToRoadmap}
        autoFocus={!onRetry}
        sx={{ ...buttonSx, color: '#fff', borderColor: '#fff' }}
      >
        Back to roadmap
      </Button>
    </Box>
  </Box>
);

export default LessonDidNotLoad;
